// extracted by mini-css-extract-plugin
export default {"uploadError":"CustomUpload_uploadError__NovpT"};